// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__6xgbB","git_link":"footer_git_link__8ZqFj","rss_year":"footer_rss_year__9Oc4h","rss":"footer_rss__Dgd2J"};